import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import {
  admin_admin,
  admin_bp,
  admin_cse,
  admin_csm,
  provider_behavioral,
  provider_pcp,
  provider_prescribe,
  provider_case_manager,
  provider_peer,
  system_workflow,
  user_patient,
} from "@/config/roles";
import { AdminRouter } from "@/portals/admin/AdminRouter";
import PatientRouter from "@/portals/patient/PatientRouter";
import { ProviderRouter } from "@/portals/provider/ProviderRouter";

import WorkflowRouter from "./Workflow/WorkflowRouter";

import "./Dashboard.scss";

// here the role will decide which roles dashboard shall beb loaded
class DashboardRouter extends Component {
  component = null;

  componentDidUpdate(prevProps) {
    if (
      prevProps.location.pathname !== "/app/schedule" &&
      this.props.location.pathname === "/app/schedule"
    ) {
      window.scrollTo(0, 0);
    }
  }

  /* oxlint-disable */
  render() {
    switch (this.props.role) {
      case admin_admin:

      case admin_bp:
      case admin_cse:
      case admin_csm:
        this.component = <AdminRouter url={this.props.match.url} />;
        break;

      case user_patient:
        this.component = <PatientRouter url={this.props.match.url} />;
        break;

      case provider_pcp:
      case provider_behavioral:
      case provider_prescribe:
      case provider_case_manager:
      case provider_peer:
        this.component = <ProviderRouter url={this.props.match.url} />;
        break;

      case system_workflow:
        this.component = <WorkflowRouter url={this.props.match.url} />;
        break;

      default:
        this.component = <PatientRouter url={this.props.match.url} />;
    }
    /* oxlint-enable */

    return (
      <div className="tw:flex tw:min-h-screen tw:flex-col tw:not-print:bg-layer-floor-0">
        {this.component}
      </div>
    );
  }
}

export default withRouter(DashboardRouter);
